/* unplugin-vue-components disabled */import script from "./TopLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./TopLinks.vue?vue&type=script&setup=true&lang=js"

import "./TopLinks.vue?vue&type=style&index=0&id=5f7659d0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7659d0"]])

export default __exports__